<div class="modal-dialog modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" style="line-height:1.2;">
				<strong>Importálás</strong>
			</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">
			<%- include('/ui/form', {
				params: [ 'import', form ],
				fields: [
					{
						type: 'file',
						name: 'file',
						title: 'XML fájl',
						attributes: {
							accept: '.xml',
							multiple: true
						}
					}
				]
			}) %>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.confirm()"><i class="fa fa-file-import me-2"></i>Import</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async confirm () {
		if (Anvil.page.modal.form.file && Anvil.page.modal.form.file.length > 0) {
			await Anvil.exec('transaction/action_import', Anvil.page.modal.form.file)
		}
	}
})
</script>
